import { Component, inject, model, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { OpportunitySnapshotsService } from "../../services/opportunity-snapshots.service";
import { SurplusLinesExistingCoverage, SurplusLinesPlanDesign, SurplusLinesPlanDesignsRequest } from "../../models/surplus-lines-plan-design.model";

@Component({
  selector: 'app-cost-of-living',
  standalone: false,
  templateUrl: './cost-of-living.component.html',
  styleUrl: '../../../assets/css/HighLimitsDialogs.css'
})
export class CostOfLivingComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<CostOfLivingComponent>);
  COLADuration: string = '';
  COLADurationOptions: string[] = [];
  cost: string = '';
  monthlyBenefit: string = '';
  eliminationPeriod: string = '';
  previousQuote: number = 0;
  planDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();
  additionalPlanDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();

  constructor(private _oss: OpportunitySnapshotsService) {
  }

  ngOnInit() {
    this.COLADurationOptions = this.getCostOfLivingOptions();
    if (this.COLADuration == '') {
      this.COLADuration = this._oss.currentQuoteOptions?.COLADurationDefault as string;
    }


    this.updateCost();
  }

  getCostOfLivingOptions() {
    if (this._oss.currentQuoteOptions == null) {
      return [];
    }
    return this._oss.currentQuoteOptions.COLADurationOptions.replaceAll('; ', ';').split(';');
  }

  updateCost() {
    var existingCoverages: SurplusLinesExistingCoverage[] = [];

    this._oss.currentOpportunitySnapshot.OtherInsurance.forEach(element => {
      var existing = new SurplusLinesExistingCoverage();
      existing.Amount = element.MonthlyAmount;
      existing.Type = element.Type;
      existing.Payee = element.Paid;
      existingCoverages.push(existing);
    });

    this.additionalPlanDesignRequest.OpportunityId = this._oss.currentCompassOpportunity?.CompassId as number;
    this.additionalPlanDesignRequest.EarnedIncome = this._oss.currentApplicant.AnnualIncome;
    this.additionalPlanDesignRequest.ExistingCoverages = existingCoverages;
    this.additionalPlanDesignRequest.InsuredId = this._oss.currentCompassOpportunity?.InsuredId as number;
    this.additionalPlanDesignRequest.TTDMonthlyBenefit = this.monthlyBenefit;
    this.additionalPlanDesignRequest.EP = this.eliminationPeriod;
    this.additionalPlanDesignRequest.COLADuration = this.COLADuration;
    this.additionalPlanDesignRequest.BenefitDuration = this._oss.currentQuoteOptions?.DurationDefault as string;

    this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.planDesignRequest).subscribe(originalQuote => {
      this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.additionalPlanDesignRequest).subscribe(additionalQuote => {
        this.cost = String(additionalQuote[0].YearOneCost - originalQuote[0].YearOneCost);
      });
    });
  }

  inclusion() {
    if (this._oss.currentQuoteOptions?.COLAInclusion == 'Y') {
      return true;
    }
    return false;
  }

  yes() {
    /** this.updateCost();**/
    this.dialogRef.close({ COLA: 1, COLADuration: this.COLADuration, cost: this.cost });
  }

  no() {
    this.dialogRef.close(false);
  }
}
